import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { DocumentService } from 'src/app/Service/document/document.service';
import { IDocumentRepositoryHistoryViewModel } from 'src/app/ViewModel/DocumentModel';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-document-repositoryhistory-dialog',
  templateUrl: './document-repositoryhistory-dialog.component.html',
  styleUrls: ['./document-repositoryhistory-dialog.component.css']
})
export class DocumentRepositoryhistoryDialogComponent implements OnInit, OnDestroy {
  selectedRepositoryHistory!: any[];
  enableFilter = false;
  enableFullscreen = false;
  pageSize = 15;
  doc_No!: string;
  UnsubscribeArray: Subscription[] = [];

  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public documentService: DocumentService,
    public _dialogRef: MatDialogRef<DocumentRepositoryhistoryDialogComponent>) { }

  ngOnInit() {
    this.doc_No = this.data.documentNo;
    this.getRepositoryHistoryDetails();
  }

  getRepositoryHistoryDetails() {
    let respositoryhistory = this.documentService.GetDocumentRepositoryhistory(this.data.docId, this.data.revision).subscribe((data: IDocumentRepositoryHistoryViewModel[]) => {
      if (data.length > 0) {
        data.forEach((value: any) => {
          value["Assigned_On"] = (moment(value.assigned_On)).format('DD-MMM-yyyy')
          if (value.viewStatus == "Read") {
            value["Date"] = (moment(value.viewed_On)).format('DD-MMM-yyyy');
          } else {
            value["Date"] = " ";
          }
        })
        this.selectedRepositoryHistory = data;
      }
    });
    this.UnsubscribeArray.push(respositoryhistory);
  }

  closeDialog() {
    this._dialogRef.close();
  }
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }
  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }
}
